export const IMAGE_SHAPES = {
  ROUNDED_RECTANGLE: 'rounded_rectangle',
  CIRCLE: 'circle',
  SQUARE: 'square',
  PORTRAIT: 'portrait'
};